/** Pack captions into free image space. Never place text over another caption. */
export interface LabelRect {x:number;y:number;width:number;height:number;}
export function placeLabel(anchor: {x:number;y:number}, size: {width:number;height:number}, canvas: {width:number;height:number}, occupied: LabelRect[]): LabelRect | null {
  const width=Math.min(size.width,canvas.width),height=size.height;
  if (height>canvas.height || width<=0) return null;
  const clamp=(v:number,lo:number,hi:number)=>Math.max(lo,Math.min(hi,v));
  const fits=(r:LabelRect)=>occupied.every(o=>r.x+r.width+3<=o.x || o.x+o.width+3<=r.x || r.y+r.height+3<=o.y || o.y+o.height+3<=r.y);
  const candidates:LabelRect[]=[];
  for (let y=0;y+height<=canvas.height;y+=height+4) {
    for (const x of [anchor.x,0,canvas.width-width]) candidates.push({x:clamp(x,0,canvas.width-width),y,width,height});
  }
  candidates.unshift({x:clamp(anchor.x,0,canvas.width-width),y:clamp(anchor.y,0,canvas.height-height),width,height});
  return candidates.filter(fits).sort((a,b)=>Math.hypot(a.x-anchor.x,a.y-anchor.y)-Math.hypot(b.x-anchor.x,b.y-anchor.y))[0] ?? null;
}
